class Events {
    constructor() {
        this.listeners = [];
        this.events = [];
        this.singles = [];
        this.eventList = {ready: "ready", page_change: "page_change", page_leave: 'page_leave', page_inject: "page_inject", page_reload: "page_reload", modal_history_back: "modal_history_back", modal_open: "modal_open", blur: "blur", focus: "focus"};
        window.addEventListener("DOMContentLoaded", () => {
            setTimeout(() => {
                this.pub(app.events.eventList.ready);
                this.pub(app.events.eventList.page_change);
            }, 1);
        });
        window.addEventListener("blur", () => {
            this.pub(this.eventList.blur);
        });
        window.addEventListener("focus", () => {
            this.pub(this.eventList.focus);
        });
    }

    pub(action) {
        if (typeof this.events[action] === "object") {
            for (let i in this.events[action]) {
                this.events[action][i]();
            }
        }
        if (typeof this.singles[action] === "object") {
            for (let i in this.singles[action]) {
                this.singles[action][i]();
                delete this.singles[action][i];
            }
        }
    }

    sub(action, func) {
        if (typeof action === "string") {
            if (typeof this.events[action] == "undefined") {
                this.events[action] = [];
            }
            this.events[action][func.toString()] = func;
        } else if (typeof action === "object") {
            for (let i in action) {
                if (typeof this.events[action[i]] == "undefined") {
                    this.events[action[i]] = [];
                }
                this.events[action[i]][func.toString()] = func;
            }
        }
    }

    single(action, func) {
        if (typeof this.singles[action] == "undefined") {
            this.singles[action] = [];
        }
        this.singles[action].push(func);
    }

    once(action, func) {
        if (typeof this.singles[action] == "undefined") {
            this.singles[action] = [];
            this.singles[action].push(func);
        } else {
            if (typeof this.singles[action] === "object") {
                let allow = true;
                for (let i in this.singles[action]) {
                    if (this.singles[action][i] === func) {
                        allow = false;
                    }
                }
                if (allow) {
                    this.singles[action].push(func);
                }
            }
        }

    }

    docSub(action, func) {
        document.addEventListener(action, func);
    }

    winSub(action, func) {
        window.addEventListener(action, func);
    }

    remove(action) {
        for (let i = 0; i < this.listeners.length; i++) {
            if (this.listeners[i].action === action) {
                document.removeEventListener(this.listeners[i].action, this.listeners[i].func);
                this.listeners.splice(i, 1);
            }
        }
    }

    onReady(callback) {
        document.addEventListener('DOMContentLoaded', callback, false);
    }

}
